import { ActionContext } from 'vuex'
import ChangeCountriesService from '@/services/Localization/changeCountries'
import { useToast } from 'vue-toastification'
import { handle418Error } from '@/utils/errorHandlers'
import i18n from '@/i18n'

const toast = useToast()

interface State {
  loading: boolean
  success: boolean
  error: any
}

const state = (): State => ({
  loading: false,
  success: false,
  error: null,
})

const mutations = {
  SET_LOADING(state: State, payload: boolean) {
    state.loading = payload
  },
  SET_SUCCESS(state: State, payload: boolean) {
    state.success = payload
  },
  SET_ERROR(state: State, payload: any) {
    state.error = payload
  },
}

const actions = {
  async changeCountries(
    { commit ,dispatch }: ActionContext<State, unknown>,
    { id, countries }: { id: number; countries: number[] }
  ) {
    commit('SET_LOADING', true)
    commit('SET_SUCCESS', false)
    commit('SET_ERROR', null)

    const response = await ChangeCountriesService.create(id, countries)
    
   
    if (response.success) {
      commit('SET_SUCCESS', true)
       toast.success(response.data.message)
        return { success: true };
    } else {
        if (response.data.status === 418) {
                 const title = `${i18n.global.t('exams.edit')} “${id}”`
        if (!handle418Error(dispatch, response.data, title)) {
          return { success: false,};
        }
         return { success: false};
          }
          
          else{
      commit('SET_ERROR', response.data.response.data.message)}
        return { success: false };
    }

  },
}

const getters = {
  isLoading: (state: State) => state.loading,
  isSuccess: (state: State) => state.success,
  getError: (state: State) => state.error,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
